import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getAvgDomesticZone,
    getZonesCount,
    getDomesticZonesByTimeframe,
    getZonesShipmentsCost
} from '../../helpers';
import {
    zonesKpisApiResponseSuccess,
    zonesKpisApiResponseError,
} from './actions';
import { ZonesKpisActionTypes } from './constants';

export function* getAvgDomesticZoneSaga({ payload: { query } }) {
    try {
        const response = yield call(getAvgDomesticZone, query);
        yield put(zonesKpisApiResponseSuccess(ZonesKpisActionTypes.GET_AVERAGE_DOMESTIC_ZONE, response.data));
    } catch (error) {
        yield put(zonesKpisApiResponseError(ZonesKpisActionTypes.GET_AVERAGE_DOMESTIC_ZONE, error));
    }
}

export function* getZonesCountSaga({ payload: { query } }) {
    try {
        const response = yield call(getZonesCount, query);
        yield put(zonesKpisApiResponseSuccess(ZonesKpisActionTypes.GET_ZONES_COUNT, response.data));
    } catch (error) {
        yield put(zonesKpisApiResponseError(ZonesKpisActionTypes.GET_ZONES_COUNT, error));
    }
}

export function* getDomesticZonesByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getDomesticZonesByTimeframe, query);
        yield put(zonesKpisApiResponseSuccess(ZonesKpisActionTypes.GET_DOMESTIC_ZONES_BY_TIMEFRAME, response.data));
    } catch (error) {
        yield put(zonesKpisApiResponseError(ZonesKpisActionTypes.GET_DOMESTIC_ZONES_BY_TIMEFRAME, error));
    }
}

export function* getZonesShipmentsCostSaga({ payload: { query } }) {
    try {
        const response = yield call(getZonesShipmentsCost, query);
        yield put(zonesKpisApiResponseSuccess(ZonesKpisActionTypes.GET_ZONES_SHIPMENTS_COST, response.data));
    } catch (error) {
        yield put(zonesKpisApiResponseError(ZonesKpisActionTypes.GET_ZONES_SHIPMENTS_COST, error));
    }
}

export function* watchGetAvgDomesticZoneSaga(): any {
    yield takeLatest(ZonesKpisActionTypes.GET_AVERAGE_DOMESTIC_ZONE, getAvgDomesticZoneSaga);
}

export function* watchGetZonesCountSaga(): any {
    yield takeLatest(ZonesKpisActionTypes.GET_ZONES_COUNT, getZonesCountSaga);
}

export function* watchGetDomesticZonesByTimeframeSaga(): any {
    yield takeLatest(ZonesKpisActionTypes.GET_DOMESTIC_ZONES_BY_TIMEFRAME, getDomesticZonesByTimeframeSaga);
}

export function* watchGetZonesShipmentsCostSaga(): any {
    yield takeLatest(ZonesKpisActionTypes.GET_ZONES_SHIPMENTS_COST, getZonesShipmentsCostSaga);
}

function* zonesKpisSaga() {
    yield all([
        fork(watchGetAvgDomesticZoneSaga),
        fork(watchGetZonesCountSaga),
        fork(watchGetDomesticZonesByTimeframeSaga),
        fork(watchGetZonesShipmentsCostSaga)
    ]);
}

export default zonesKpisSaga;
